// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  formDataBodySerializer,
  type Options as Options2,
  type TDataShape,
} from './client';
import { client } from './client.gen';
import type {
  AnnouncementsGetData,
  AnnouncementsGetResponses,
  AnnouncementsTrackingPostData,
  AnnouncementsTrackingPostResponses,
  BatchFormAggregationsData,
  BatchFormAggregationsErrors,
  BatchFormAggregationsResponses,
  BatchFormDeleteData,
  BatchFormDeleteErrors,
  BatchFormDeleteResponses,
  BatchFormGetData,
  BatchFormGetErrors,
  BatchFormGetResponses,
  BatchFormGetVersionsData,
  BatchFormGetVersionsErrors,
  BatchFormGetVersionsResponses,
  BatchFormPatchData,
  BatchFormPatchErrors,
  BatchFormPatchResponses,
  BatchFormPostData,
  BatchFormPostErrors,
  BatchFormPostResponses,
  BatchFormPutData,
  BatchFormPutErrors,
  BatchFormPutResponses,
  BatchLayerPutAutoincrementData,
  BatchLayerPutAutoincrementResponses,
  BatchTemplateGetDeltasData,
  BatchTemplateGetDeltasErrors,
  BatchTemplateGetDeltasResponses,
  DataUpdateJobDeleteData,
  DataUpdateJobDeleteResponses,
  DataUpdateJobGetByTodoIdData,
  DataUpdateJobGetByTodoIdResponses,
  DataUpdateJobGetData,
  DataUpdateJobGetResponses,
  DataUpdateJobListData,
  DataUpdateJobListResponses,
  DataUpdateJobPatchData,
  DataUpdateJobPatchResponses,
  DataUpdateJobPostData,
  DataUpdateJobPostResponses,
  DataUpdateJobPutData,
  DataUpdateJobPutResponses,
  DataUpdateJobQueryData,
  DataUpdateJobQueryResponses,
  DataUpdateJobSearchData,
  DataUpdateJobSearchResponses,
  DatumsListData,
  DatumsListResponses,
  EntitlementActivationsGetData,
  EntitlementActivationsGetResponses,
  ExportJobGetData,
  ExportJobGetDownloadUrlData,
  ExportJobGetDownloadUrlResponses,
  ExportJobGetResponses,
  ExportJobListData,
  ExportJobListResponses,
  ExportJobPostData,
  ExportJobPostResponses,
  ExportJobQueryData,
  ExportJobQueryResponses,
  FeatureImageGetData,
  FeatureImageGetResponses,
  FieldGetData,
  FieldGetResponses,
  FieldListData,
  FieldListResponses,
  FieldQueryData,
  FieldQueryResponses,
  FlagDeleteData,
  FlagDeleteResponses,
  FlagPostData,
  FlagPostResponses,
  FlagPutData,
  FlagPutResponses,
  FlagsGetData,
  FlagsGetResponses,
  FormAggregationsData,
  FormAggregationsErrors,
  FormAggregationsResponses,
  FormDeleteData,
  FormDeleteErrors,
  FormDeleteResponses,
  FormGetData,
  FormGetErrors,
  FormGetResponses,
  FormGetVersionsData,
  FormGetVersionsErrors,
  FormGetVersionsResponses,
  FormImageGetData,
  FormImageGetResponses,
  FormPatchData,
  FormPatchErrors,
  FormPatchResponses,
  FormPostData,
  FormPostErrors,
  FormPostResponses,
  FormPutData,
  FormPutErrors,
  FormPutResponses,
  FormQueryData,
  FormQueryErrors,
  FormQueryResponses,
  GetAuthCurrentuserData,
  GetAuthCurrentuserResponses,
  GetMembershipData,
  GetMembershipResponses,
  GetMigrationJobData,
  GetMigrationJobResponses,
  GetprepareddataData,
  GetprepareddataResponses,
  GetSensorsData,
  GetSensorsResponses,
  GisJobDeleteData,
  GisJobDeleteResponses,
  GisJobGetData,
  GisJobGetResponses,
  GisJobPatchData,
  GisJobPatchResponses,
  GisJobPostData,
  GisJobPostResponses,
  GisJobQueryData,
  GisJobQueryResponses,
  GisReturnJobDeleteData,
  GisReturnJobDeleteResponses,
  GisReturnJobListData,
  GisReturnJobListResponses,
  GisReturnJobPostData,
  GisReturnJobPostResponses,
  GroupListData,
  GroupListResponses,
  ImportJobGetData,
  ImportJobGetResponses,
  ImportJobPostData,
  ImportJobPostResponses,
  ImportJobSelectData,
  ImportJobSelectResponses,
  LayerDeleteData,
  LayerDeleteResponses,
  LayerGetData,
  LayerGetResponses,
  LayerGetTemplateData,
  LayerGetTemplateResponses,
  LayerListData,
  LayerListResponses,
  LayerPostData,
  LayerPostResponses,
  LayerPutAutoincrementData,
  LayerPutAutoincrementResponses,
  LayerPutData,
  LayerPutResponses,
  LayerQueryData,
  LayerQueryResponses,
  LayerRelationshipsCreateData,
  LayerRelationshipsCreateResponses,
  LayerRelationshipsPatchData,
  LayerRelationshipsPatchResponses,
  ListRegionsData,
  ListRegionsResponses,
  ListTcProjectsData,
  ListTcProjectsResponses,
  MapCacheDeleteData,
  MapCacheDeleteResponses,
  MapCacheGetData,
  MapCacheGetDownloadUrlData,
  MapCacheGetDownloadUrlResponses,
  MapCacheGetResponses,
  MapCacheListData,
  MapCacheListResponses,
  MapCachePatchData,
  MapCachePatchResponses,
  MapCachePostData,
  MapCachePostResponses,
  MapCacheQueryData,
  MapCacheQueryResponses,
  NtripSettingsListData,
  NtripSettingsListResponses,
  ProjectImageDeleteData,
  ProjectImageDeleteResponses,
  ProjectImageGetData,
  ProjectImageGetResponses,
  ProjectImagePostData,
  ProjectImagePostResponses,
  RealtimeCorrectionDeleteData,
  RealtimeCorrectionDeleteResponses,
  RealtimeCorrectionGetData,
  RealtimeCorrectionGetResponses,
  RealtimeCorrectionListData,
  RealtimeCorrectionListResponses,
  RealtimeCorrectionPostData,
  RealtimeCorrectionPostResponses,
  RealtimeCorrectionPutData,
  RealtimeCorrectionPutResponses,
  ReturnJobDeleteData,
  ReturnJobDeleteResponses,
  ReturnJobGetData,
  ReturnJobGetResponses,
  ReturnJobListData,
  ReturnJobListResponses,
  ReturnJobPostData,
  ReturnJobPostResponses,
  RevokeTokenData,
  RevokeTokenResponses,
  SpatialFileGetByIdData,
  SpatialFileGetByIdResponses,
  SpatialFileListData,
  SpatialFileListResponses,
  StartMigrationData,
  StartMigrationResponses,
  StyleDeleteData,
  StyleDeleteResponses,
  StyleGetData,
  StyleGetResponses,
  StyleListData,
  StyleListResponses,
  StyleOverrideDeleteData,
  StyleOverrideDeleteResponses,
  StyleOverrideGetData,
  StyleOverrideGetResponses,
  StyleOverrideListData,
  StyleOverrideListResponses,
  StyleOverridePostData,
  StyleOverridePostResponses,
  StyleOverridePutByIdData,
  StyleOverridePutByIdResponses,
  StyleOverridePutData,
  StyleOverridePutResponses,
  StyleOverridesPostData,
  StyleOverridesPostResponses,
  StylePostData,
  StylePostResponses,
  StylePutData,
  StylePutResponses,
  SupportedColorsListData,
  SupportedColorsListResponses,
  SurveyJobDownloadPackageData,
  SurveyJobDownloadPackageResponses,
  SurveyJobGetAttachmentsData,
  SurveyJobGetAttachmentsResponses,
  SurveyJobGetData,
  SurveyJobGetFilesData,
  SurveyJobGetFilesResponses,
  SurveyJobGetLinkedFilesData,
  SurveyJobGetLinkedFilesResponses,
  SurveyJobGetResponses,
  SurveyJobPatchData,
  SurveyJobPatchResponses,
  SurveyJobPostData,
  SurveyJobPostResponses,
  SurveyJobQueryData,
  SurveyJobQueryResponses,
  SymbolDefinitionsListData,
  SymbolDefinitionsListResponses,
  SymbolDeleteData,
  SymbolDeleteResponses,
  SymbolGetData,
  SymbolGetResponses,
  SymbolListData,
  SymbolListResponses,
  SymbolPostData,
  SymbolPostResponses,
  SymbolPutData,
  SymbolPutResponses,
  TemplateDeleteData,
  TemplateDeleteResponses,
  TemplateGetData,
  TemplateGetDeltasData,
  TemplateGetDeltasResponses,
  TemplateGetLatestPublishedData,
  TemplateGetLatestPublishedResponses,
  TemplateGetLatestPublishedSeriesData,
  TemplateGetLatestPublishedSeriesResponses,
  TemplateGetLatestSeriesData,
  TemplateGetLatestSeriesResponses,
  TemplateGetResponses,
  TemplateGetSeriesData,
  TemplateGetSeriesResponses,
  TemplateListData,
  TemplateListResponses,
  TemplatePostData,
  TemplatePostResponses,
  TemplatePublicationPostData,
  TemplatePublicationPostResponses,
  TemplatePublicationQueryData,
  TemplatePublicationQueryResponses,
  TemplatePutData,
  TemplatePutResponses,
  TemplateQueryData,
  TemplateQueryResponses,
  TemplateRelationshipsCreateData,
  TemplateRelationshipsCreateResponses,
  TemplateRelationshipsGetData,
  TemplateRelationshipsGetResponses,
  TrimbleDataGetData,
  TrimbleDataGetGeocodeData,
  TrimbleDataGetGeocodeResponses,
  TrimbleDataGetResponses,
  UserListData,
  UserListResponses,
  UserSettingsDeleteData,
  UserSettingsDeleteResponses,
  UserSettingsGetByTypeData,
  UserSettingsGetByTypeResponses,
  UserSettingsGetData,
  UserSettingsGetResponses,
  UserSettingsPostData,
  UserSettingsPostResponses,
  UserSettingsPutData,
  UserSettingsPutResponses,
  WorkspaceDeleteData,
  WorkspaceDeleteResponses,
  WorkspaceDuplicatePostData,
  WorkspaceDuplicatePostResponses,
  WorkspaceGetByFileIdData,
  WorkspaceGetByFileIdResponses,
  WorkspaceGetData,
  WorkspaceGetImageData,
  WorkspaceGetImageResponses,
  WorkspaceGetResponses,
  WorkspaceGetSurveyData,
  WorkspaceGetSurveyResponses,
  WorkspaceGetViewerData,
  WorkspaceGetViewerResponses,
  WorkspaceImportPostData,
  WorkspaceImportPostResponses,
  WorkspaceListData,
  WorkspaceListOrphanData,
  WorkspaceListOrphanResponses,
  WorkspaceListResponses,
  WorkspacePatchData,
  WorkspacePatchResponses,
  WorkspacePostData,
  WorkspacePostResponses,
  WorkspacePutData,
  WorkspacePutImageData,
  WorkspacePutImageResponses,
  WorkspacePutResponses,
  WorkspaceQueryData,
  WorkspaceQueryResponses,
  WorkspaceRelationshipsDeleteData,
  WorkspaceRelationshipsDeleteResponses,
  WorkspaceRelationshipsPatchData,
  WorkspaceRelationshipsPatchResponses,
  WorkspaceRelationshipsUpdateData,
  WorkspaceRelationshipsUpdateResponses,
  WorkspaceRestoreData,
  WorkspaceRestoreResponses,
} from './types.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

export const announcementsTrackingPost = <ThrowOnError extends boolean = false>(
  options?: Options<AnnouncementsTrackingPostData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    AnnouncementsTrackingPostResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/announcements/tracking',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const announcementsGet = <ThrowOnError extends boolean = false>(
  options?: Options<AnnouncementsGetData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    AnnouncementsGetResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/announcements',
    ...options,
  });

export const revokeToken = <ThrowOnError extends boolean = false>(
  options?: Options<RevokeTokenData, ThrowOnError>
) =>
  (options?.client ?? client).post<RevokeTokenResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/auth/revoke',
      ...options,
    }
  );

export const getAuthCurrentuser = <ThrowOnError extends boolean = false>(
  options?: Options<GetAuthCurrentuserData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    GetAuthCurrentuserResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/auth/currentuser',
    ...options,
  });

export const dataUpdateJobList = <ThrowOnError extends boolean = false>(
  options: Options<DataUpdateJobListData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DataUpdateJobListResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/dataupdatejobs',
    ...options,
  });

export const dataUpdateJobPost = <ThrowOnError extends boolean = false>(
  options: Options<DataUpdateJobPostData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DataUpdateJobPostResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/dataupdatejobs',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const dataUpdateJobDelete = <ThrowOnError extends boolean = false>(
  options: Options<DataUpdateJobDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DataUpdateJobDeleteResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/dataupdatejobs/{id}',
    ...options,
  });

export const dataUpdateJobGet = <ThrowOnError extends boolean = false>(
  options: Options<DataUpdateJobGetData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DataUpdateJobGetResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/dataupdatejobs/{id}',
    ...options,
  });

export const dataUpdateJobPatch = <ThrowOnError extends boolean = false>(
  options: Options<DataUpdateJobPatchData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    DataUpdateJobPatchResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/dataupdatejobs/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const dataUpdateJobPut = <ThrowOnError extends boolean = false>(
  options: Options<DataUpdateJobPutData, ThrowOnError>
) =>
  (options.client ?? client).put<
    DataUpdateJobPutResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/dataupdatejobs/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const dataUpdateJobGetByTodoId = <ThrowOnError extends boolean = false>(
  options: Options<DataUpdateJobGetByTodoIdData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DataUpdateJobGetByTodoIdResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/dataupdatejobs/todos/{todoId}',
    ...options,
  });

export const dataUpdateJobQuery = <ThrowOnError extends boolean = false>(
  options: Options<DataUpdateJobQueryData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DataUpdateJobQueryResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/dataupdatejobs/_query',
    ...options,
  });

/**
 * @deprecated
 */
export const dataUpdateJobSearch = <ThrowOnError extends boolean = false>(
  options: Options<DataUpdateJobSearchData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DataUpdateJobSearchResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/dataupdatejobs/_search',
    ...options,
  });

export const returnJobDelete = <ThrowOnError extends boolean = false>(
  options: Options<ReturnJobDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ReturnJobDeleteResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/dataupdatejobs/{id}/returns',
    ...options,
  });

export const returnJobList = <ThrowOnError extends boolean = false>(
  options: Options<ReturnJobListData, ThrowOnError>
) =>
  (options.client ?? client).get<ReturnJobListResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/projects/{projectId}/dataupdatejobs/{id}/returns',
      ...options,
    }
  );

export const returnJobPost = <ThrowOnError extends boolean = false>(
  options: Options<ReturnJobPostData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ReturnJobPostResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/dataupdatejobs/{id}/returns',
    ...options,
  });

/**
 * @deprecated
 */
export const returnJobGet = <ThrowOnError extends boolean = false>(
  options: Options<ReturnJobGetData, ThrowOnError>
) =>
  (options.client ?? client).get<ReturnJobGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/dataupdatejobs/{id}/returns/{returnId}',
    ...options,
  });

export const entitlementActivationsGet = <ThrowOnError extends boolean = false>(
  options?: Options<EntitlementActivationsGetData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    EntitlementActivationsGetResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/entitlement/activations',
    ...options,
  });

export const exportJobList = <ThrowOnError extends boolean = false>(
  options: Options<ExportJobListData, ThrowOnError>
) =>
  (options.client ?? client).get<ExportJobListResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/projects/{projectId}/formexports',
      ...options,
    }
  );

export const exportJobPost = <ThrowOnError extends boolean = false>(
  options: Options<ExportJobPostData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ExportJobPostResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/formexports',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const exportJobGet = <ThrowOnError extends boolean = false>(
  options: Options<ExportJobGetData, ThrowOnError>
) =>
  (options.client ?? client).get<ExportJobGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/formexports/{id}',
    ...options,
  });

export const exportJobGetDownloadUrl = <ThrowOnError extends boolean = false>(
  options: Options<ExportJobGetDownloadUrlData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ExportJobGetDownloadUrlResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/formexports/{id}/download',
    ...options,
  });

export const exportJobQuery = <ThrowOnError extends boolean = false>(
  options: Options<ExportJobQueryData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ExportJobQueryResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/formexports/_query',
    ...options,
  });

export const getprepareddata = <ThrowOnError extends boolean = false>(
  options: Options<GetprepareddataData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetprepareddataResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/formexports/getprepareddata',
    ...options,
  });

export const flagDelete = <ThrowOnError extends boolean = false>(
  options?: Options<FlagDeleteData, ThrowOnError>
) =>
  (options?.client ?? client).delete<
    FlagDeleteResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/featureflags',
    ...options,
  });

export const flagsGet = <ThrowOnError extends boolean = false>(
  options?: Options<FlagsGetData, ThrowOnError>
) =>
  (options?.client ?? client).get<FlagsGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/featureflags',
    ...options,
  });

export const flagPost = <ThrowOnError extends boolean = false>(
  options?: Options<FlagPostData, ThrowOnError>
) =>
  (options?.client ?? client).post<FlagPostResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/featureflags',
    ...options,
  });

export const flagPut = <ThrowOnError extends boolean = false>(
  options?: Options<FlagPutData, ThrowOnError>
) =>
  (options?.client ?? client).put<FlagPutResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/featureflags',
    ...options,
  });

/**
 * @deprecated
 */
export const featureImageGet = <ThrowOnError extends boolean = false>(
  options: Options<FeatureImageGetData, ThrowOnError>
) =>
  (options.client ?? client).get<
    FeatureImageGetResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/features/images/{imageId}',
    ...options,
  });

export const importJobGet = <ThrowOnError extends boolean = false>(
  options: Options<ImportJobGetData, ThrowOnError>
) =>
  (options.client ?? client).get<ImportJobGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/featureimport',
    ...options,
  });

export const importJobPost = <ThrowOnError extends boolean = false>(
  options: Options<ImportJobPostData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ImportJobPostResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/featureimport',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const importJobSelect = <ThrowOnError extends boolean = false>(
  options: Options<ImportJobSelectData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ImportJobSelectResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/featureimport/{importId}',
    ...options,
  });

export const fieldGet = <ThrowOnError extends boolean = false>(
  options: Options<FieldGetData, ThrowOnError>
) =>
  (options.client ?? client).get<FieldGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fields/{id}',
    ...options,
  });

export const fieldList = <ThrowOnError extends boolean = false>(
  options?: Options<FieldListData, ThrowOnError>
) =>
  (options?.client ?? client).get<FieldListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fields',
    ...options,
  });

export const fieldQuery = <ThrowOnError extends boolean = false>(
  options?: Options<FieldQueryData, ThrowOnError>
) =>
  (options?.client ?? client).get<FieldQueryResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fields/_query',
    ...options,
  });

export const formImageGet = <ThrowOnError extends boolean = false>(
  options: Options<FormImageGetData, ThrowOnError>
) =>
  (options.client ?? client).get<FormImageGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/forms/images/{imageId}',
    ...options,
  });

export const formPost = <ThrowOnError extends boolean = false>(
  options: Options<FormPostData, ThrowOnError>
) =>
  (options.client ?? client).post<
    FormPostResponses,
    FormPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/forms',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const formDelete = <ThrowOnError extends boolean = false>(
  options: Options<FormDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    FormDeleteResponses,
    FormDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/forms/{id}',
    ...options,
  });

export const formGet = <ThrowOnError extends boolean = false>(
  options: Options<FormGetData, ThrowOnError>
) =>
  (options.client ?? client).get<FormGetResponses, FormGetErrors, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/projects/{projectId}/forms/{id}',
      ...options,
    }
  );

export const formPatch = <ThrowOnError extends boolean = false>(
  options: Options<FormPatchData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    FormPatchResponses,
    FormPatchErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/forms/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const formPut = <ThrowOnError extends boolean = false>(
  options: Options<FormPutData, ThrowOnError>
) =>
  (options.client ?? client).put<FormPutResponses, FormPutErrors, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/projects/{projectId}/forms/{id}',
      ...options,
      headers: {
        'Content-Type': 'application/json-patch+json',
        ...options.headers,
      },
    }
  );

export const formGetVersions = <ThrowOnError extends boolean = false>(
  options: Options<FormGetVersionsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    FormGetVersionsResponses,
    FormGetVersionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/forms/{id}/versions',
    ...options,
  });

export const formAggregations = <ThrowOnError extends boolean = false>(
  options: Options<FormAggregationsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    FormAggregationsResponses,
    FormAggregationsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/forms/_aggregate/_get',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const formQuery = <ThrowOnError extends boolean = false>(
  options: Options<FormQueryData, ThrowOnError>
) =>
  (options.client ?? client).post<
    FormQueryResponses,
    FormQueryErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/forms/_query',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const batchFormPost = <ThrowOnError extends boolean = false>(
  options: Options<BatchFormPostData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BatchFormPostResponses,
    BatchFormPostErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/forms/_batch/_post',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const batchFormPut = <ThrowOnError extends boolean = false>(
  options: Options<BatchFormPutData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BatchFormPutResponses,
    BatchFormPutErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/forms/_batch/_put',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const batchFormPatch = <ThrowOnError extends boolean = false>(
  options: Options<BatchFormPatchData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BatchFormPatchResponses,
    BatchFormPatchErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/forms/_batch/_patch',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const batchFormGetVersions = <ThrowOnError extends boolean = false>(
  options: Options<BatchFormGetVersionsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BatchFormGetVersionsResponses,
    BatchFormGetVersionsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/forms/versions/_batch/_get',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const batchFormGet = <ThrowOnError extends boolean = false>(
  options: Options<BatchFormGetData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BatchFormGetResponses,
    BatchFormGetErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/forms/_batch/_get',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const batchFormDelete = <ThrowOnError extends boolean = false>(
  options: Options<BatchFormDeleteData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BatchFormDeleteResponses,
    BatchFormDeleteErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/forms/_batch/_delete',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const batchFormAggregations = <ThrowOnError extends boolean = false>(
  options: Options<BatchFormAggregationsData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BatchFormAggregationsResponses,
    BatchFormAggregationsErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/forms/_aggregates/_batch/_get',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const gisJobPost = <ThrowOnError extends boolean = false>(
  options: Options<GisJobPostData, ThrowOnError>
) =>
  (options.client ?? client).post<GisJobPostResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/gisjobs',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const gisJobDelete = <ThrowOnError extends boolean = false>(
  options: Options<GisJobDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    GisJobDeleteResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/gisjobs/{id}',
    ...options,
  });

export const gisJobGet = <ThrowOnError extends boolean = false>(
  options: Options<GisJobGetData, ThrowOnError>
) =>
  (options.client ?? client).get<GisJobGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/gisjobs/{id}',
    ...options,
  });

export const gisJobPatch = <ThrowOnError extends boolean = false>(
  options: Options<GisJobPatchData, ThrowOnError>
) =>
  (options.client ?? client).patch<GisJobPatchResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/projects/{projectId}/gisjobs/{id}',
      ...options,
      headers: {
        'Content-Type': 'application/json-patch+json',
        ...options.headers,
      },
    }
  );

export const gisJobQuery = <ThrowOnError extends boolean = false>(
  options: Options<GisJobQueryData, ThrowOnError>
) =>
  (options.client ?? client).get<GisJobQueryResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/gisjobs/_query',
    ...options,
  });

export const gisReturnJobDelete = <ThrowOnError extends boolean = false>(
  options: Options<GisReturnJobDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    GisReturnJobDeleteResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/gisjobs/{id}/returns',
    ...options,
  });

export const gisReturnJobList = <ThrowOnError extends boolean = false>(
  options: Options<GisReturnJobListData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GisReturnJobListResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/gisjobs/{id}/returns',
    ...options,
  });

export const gisReturnJobPost = <ThrowOnError extends boolean = false>(
  options: Options<GisReturnJobPostData, ThrowOnError>
) =>
  (options.client ?? client).post<
    GisReturnJobPostResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/gisjobs/{id}/returns',
    ...options,
  });

export const projectImagePost = <ThrowOnError extends boolean = false>(
  options: Options<ProjectImagePostData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProjectImagePostResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/images',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const projectImageDelete = <ThrowOnError extends boolean = false>(
  options: Options<ProjectImageDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ProjectImageDeleteResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/images/{uuid}',
    ...options,
  });

export const projectImageGet = <ThrowOnError extends boolean = false>(
  options: Options<ProjectImageGetData, ThrowOnError>
) =>
  (options.client ?? client).get<
    ProjectImageGetResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/images/{uuid}',
    ...options,
  });

export const layerList = <ThrowOnError extends boolean = false>(
  options: Options<LayerListData, ThrowOnError>
) =>
  (options.client ?? client).get<LayerListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/layers',
    ...options,
  });

export const layerPost = <ThrowOnError extends boolean = false>(
  options: Options<LayerPostData, ThrowOnError>
) =>
  (options.client ?? client).post<LayerPostResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/layers',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const layerGetTemplate = <ThrowOnError extends boolean = false>(
  options: Options<LayerGetTemplateData, ThrowOnError>
) =>
  (options.client ?? client).get<
    LayerGetTemplateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/layers/{id}/template',
    ...options,
  });

export const layerDelete = <ThrowOnError extends boolean = false>(
  options: Options<LayerDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    LayerDeleteResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/layers/{id}',
    ...options,
  });

export const layerGet = <ThrowOnError extends boolean = false>(
  options: Options<LayerGetData, ThrowOnError>
) =>
  (options.client ?? client).get<LayerGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/layers/{id}',
    ...options,
  });

export const layerPut = <ThrowOnError extends boolean = false>(
  options: Options<LayerPutData, ThrowOnError>
) =>
  (options.client ?? client).put<LayerPutResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/layers/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const layerQuery = <ThrowOnError extends boolean = false>(
  options: Options<LayerQueryData, ThrowOnError>
) =>
  (options.client ?? client).get<LayerQueryResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/layers/_query',
    ...options,
  });

export const layerPutAutoincrement = <ThrowOnError extends boolean = false>(
  options: Options<LayerPutAutoincrementData, ThrowOnError>
) =>
  (options.client ?? client).put<
    LayerPutAutoincrementResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/layers/{id}/autoincrement',
    ...options,
  });

export const batchLayerPutAutoincrement = <
  ThrowOnError extends boolean = false,
>(
  options: Options<BatchLayerPutAutoincrementData, ThrowOnError>
) =>
  (options.client ?? client).put<
    BatchLayerPutAutoincrementResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/layers/autoincrement/_batch/_put',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const layerRelationshipsPatch = <ThrowOnError extends boolean = false>(
  options: Options<LayerRelationshipsPatchData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    LayerRelationshipsPatchResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/layers/relationships',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const layerRelationshipsCreate = <ThrowOnError extends boolean = false>(
  options: Options<LayerRelationshipsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    LayerRelationshipsCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/layers/relationships',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const mapCacheList = <ThrowOnError extends boolean = false>(
  options: Options<MapCacheListData, ThrowOnError>
) =>
  (options.client ?? client).get<MapCacheListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/mapcaches',
    ...options,
  });

export const mapCachePost = <ThrowOnError extends boolean = false>(
  options: Options<MapCachePostData, ThrowOnError>
) =>
  (options.client ?? client).post<MapCachePostResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/projects/{projectId}/mapcaches',
      ...options,
      headers: {
        'Content-Type': 'application/json-patch+json',
        ...options.headers,
      },
    }
  );

export const mapCacheDelete = <ThrowOnError extends boolean = false>(
  options: Options<MapCacheDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    MapCacheDeleteResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/mapcaches/{id}',
    ...options,
  });

export const mapCacheGet = <ThrowOnError extends boolean = false>(
  options: Options<MapCacheGetData, ThrowOnError>
) =>
  (options.client ?? client).get<MapCacheGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/mapcaches/{id}',
    ...options,
  });

export const mapCachePatch = <ThrowOnError extends boolean = false>(
  options: Options<MapCachePatchData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    MapCachePatchResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/mapcaches/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const mapCacheQuery = <ThrowOnError extends boolean = false>(
  options: Options<MapCacheQueryData, ThrowOnError>
) =>
  (options.client ?? client).get<MapCacheQueryResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/projects/{projectId}/mapcaches/_query',
      ...options,
    }
  );

export const mapCacheGetDownloadUrl = <ThrowOnError extends boolean = false>(
  options: Options<MapCacheGetDownloadUrlData, ThrowOnError>
) =>
  (options.client ?? client).get<
    MapCacheGetDownloadUrlResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/mapcaches/{jobToken}/content',
    ...options,
  });

export const listTcProjects = <ThrowOnError extends boolean = false>(
  options?: Options<ListTcProjectsData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    ListTcProjectsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects',
    ...options,
  });

export const userList = <ThrowOnError extends boolean = false>(
  options: Options<UserListData, ThrowOnError>
) =>
  (options.client ?? client).get<UserListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/users',
    ...options,
  });

export const groupList = <ThrowOnError extends boolean = false>(
  options: Options<GroupListData, ThrowOnError>
) =>
  (options.client ?? client).get<GroupListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/groups',
    ...options,
  });

export const spatialFileGetById = <ThrowOnError extends boolean = false>(
  options: Options<SpatialFileGetByIdData, ThrowOnError>
) =>
  (options.client ?? client).get<
    SpatialFileGetByIdResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/spatialfiles/{fileId}',
    ...options,
  });

export const spatialFileList = <ThrowOnError extends boolean = false>(
  options: Options<SpatialFileListData, ThrowOnError>
) =>
  (options.client ?? client).get<
    SpatialFileListResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/spatialfiles',
    ...options,
  });

export const getMembership = <ThrowOnError extends boolean = false>(
  options: Options<GetMembershipData, ThrowOnError>
) =>
  (options.client ?? client).get<GetMembershipResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/projects/{projectId}/memberships',
      ...options,
    }
  );

export const realtimeCorrectionList = <ThrowOnError extends boolean = false>(
  options: Options<RealtimeCorrectionListData, ThrowOnError>
) =>
  (options.client ?? client).get<
    RealtimeCorrectionListResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/realtimecorrections',
    ...options,
  });

export const realtimeCorrectionPost = <ThrowOnError extends boolean = false>(
  options: Options<RealtimeCorrectionPostData, ThrowOnError>
) =>
  (options.client ?? client).post<
    RealtimeCorrectionPostResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/realtimecorrections',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const realtimeCorrectionDelete = <ThrowOnError extends boolean = false>(
  options: Options<RealtimeCorrectionDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    RealtimeCorrectionDeleteResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/realtimecorrections/{id}',
    ...options,
  });

export const realtimeCorrectionGet = <ThrowOnError extends boolean = false>(
  options: Options<RealtimeCorrectionGetData, ThrowOnError>
) =>
  (options.client ?? client).get<
    RealtimeCorrectionGetResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/realtimecorrections/{id}',
    ...options,
  });

export const realtimeCorrectionPut = <ThrowOnError extends boolean = false>(
  options: Options<RealtimeCorrectionPutData, ThrowOnError>
) =>
  (options.client ?? client).put<
    RealtimeCorrectionPutResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/realtimecorrections/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const datumsList = <ThrowOnError extends boolean = false>(
  options?: Options<DatumsListData, ThrowOnError>
) =>
  (options?.client ?? client).get<DatumsListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/realtimecorrections/datums',
    ...options,
  });

export const ntripSettingsList = <ThrowOnError extends boolean = false>(
  options?: Options<NtripSettingsListData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    NtripSettingsListResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/realtimecorrections/ntripsettings',
    ...options,
  });

export const listRegions = <ThrowOnError extends boolean = false>(
  options?: Options<ListRegionsData, ThrowOnError>
) =>
  (options?.client ?? client).get<ListRegionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/regions',
    ...options,
  });

export const getSensors = <ThrowOnError extends boolean = false>(
  options?: Options<GetSensorsData, ThrowOnError>
) =>
  (options?.client ?? client).get<GetSensorsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/sensors',
    ...options,
  });

export const styleList = <ThrowOnError extends boolean = false>(
  options: Options<StyleListData, ThrowOnError>
) =>
  (options.client ?? client).get<StyleListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/styles',
    ...options,
  });

export const stylePost = <ThrowOnError extends boolean = false>(
  options: Options<StylePostData, ThrowOnError>
) =>
  (options.client ?? client).post<StylePostResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/styles',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const styleDelete = <ThrowOnError extends boolean = false>(
  options: Options<StyleDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    StyleDeleteResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/styles/{id}',
    ...options,
  });

export const styleGet = <ThrowOnError extends boolean = false>(
  options: Options<StyleGetData, ThrowOnError>
) =>
  (options.client ?? client).get<StyleGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/styles/{id}',
    ...options,
  });

export const stylePut = <ThrowOnError extends boolean = false>(
  options: Options<StylePutData, ThrowOnError>
) =>
  (options.client ?? client).put<StylePutResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/styles/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const supportedColorsList = <ThrowOnError extends boolean = false>(
  options?: Options<SupportedColorsListData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    SupportedColorsListResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/styles/colors',
    ...options,
  });

export const styleOverridePost = <ThrowOnError extends boolean = false>(
  options: Options<StyleOverridePostData, ThrowOnError>
) =>
  (options.client ?? client).post<
    StyleOverridePostResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/styles/{styleId}/styleoverrides',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const styleOverridesPost = <ThrowOnError extends boolean = false>(
  options: Options<StyleOverridesPostData, ThrowOnError>
) =>
  (options.client ?? client).post<
    StyleOverridesPostResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/styles/{styleId}/styleoverrides/_bulk/_post',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const styleOverrideDelete = <ThrowOnError extends boolean = false>(
  options: Options<StyleOverrideDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    StyleOverrideDeleteResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/styleoverrides/{id}',
    ...options,
  });

export const styleOverrideGet = <ThrowOnError extends boolean = false>(
  options: Options<StyleOverrideGetData, ThrowOnError>
) =>
  (options.client ?? client).get<
    StyleOverrideGetResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/styleoverrides/{id}',
    ...options,
  });

export const styleOverridePutById = <ThrowOnError extends boolean = false>(
  options: Options<StyleOverridePutByIdData, ThrowOnError>
) =>
  (options.client ?? client).put<
    StyleOverridePutByIdResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/styleoverrides/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const styleOverridePut = <ThrowOnError extends boolean = false>(
  options: Options<StyleOverridePutData, ThrowOnError>
) =>
  (options.client ?? client).put<
    StyleOverridePutResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/styles/{styleId}/styleoverrides/_bulk/_put',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const styleOverrideList = <ThrowOnError extends boolean = false>(
  options: Options<StyleOverrideListData, ThrowOnError>
) =>
  (options.client ?? client).get<
    StyleOverrideListResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/styleoverrides',
    ...options,
  });

export const surveyJobPost = <ThrowOnError extends boolean = false>(
  options: Options<SurveyJobPostData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SurveyJobPostResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/surveyjobs',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const surveyJobGet = <ThrowOnError extends boolean = false>(
  options: Options<SurveyJobGetData, ThrowOnError>
) =>
  (options.client ?? client).get<SurveyJobGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/surveyjobs/{id}',
    ...options,
  });

export const surveyJobPatch = <ThrowOnError extends boolean = false>(
  options: Options<SurveyJobPatchData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    SurveyJobPatchResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/surveyjobs/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const surveyJobQuery = <ThrowOnError extends boolean = false>(
  options: Options<SurveyJobQueryData, ThrowOnError>
) =>
  (options.client ?? client).get<
    SurveyJobQueryResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/surveyjobs/_query',
    ...options,
  });

export const surveyJobGetAttachments = <ThrowOnError extends boolean = false>(
  options: Options<SurveyJobGetAttachmentsData, ThrowOnError>
) =>
  (options.client ?? client).get<
    SurveyJobGetAttachmentsResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/surveyjobs/{id}/attachments',
    ...options,
  });

export const surveyJobGetLinkedFiles = <ThrowOnError extends boolean = false>(
  options: Options<SurveyJobGetLinkedFilesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    SurveyJobGetLinkedFilesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/surveyjobs/{id}/linkedfiles',
    ...options,
  });

export const surveyJobGetFiles = <ThrowOnError extends boolean = false>(
  options: Options<SurveyJobGetFilesData, ThrowOnError>
) =>
  (options.client ?? client).post<
    SurveyJobGetFilesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/surveyjobs/files',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const surveyJobDownloadPackage = <ThrowOnError extends boolean = false>(
  options: Options<SurveyJobDownloadPackageData, ThrowOnError>
) =>
  (options.client ?? client).get<
    SurveyJobDownloadPackageResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/surveyjobs/{id}/download',
    ...options,
  });

export const symbolList = <ThrowOnError extends boolean = false>(
  options: Options<SymbolListData, ThrowOnError>
) =>
  (options.client ?? client).get<SymbolListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/symbols',
    ...options,
  });

export const symbolPost = <ThrowOnError extends boolean = false>(
  options: Options<SymbolPostData, ThrowOnError>
) =>
  (options.client ?? client).post<SymbolPostResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/symbols',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const symbolDelete = <ThrowOnError extends boolean = false>(
  options: Options<SymbolDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    SymbolDeleteResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/symbols/{id}',
    ...options,
  });

export const symbolGet = <ThrowOnError extends boolean = false>(
  options: Options<SymbolGetData, ThrowOnError>
) =>
  (options.client ?? client).get<SymbolGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/symbols/{id}',
    ...options,
  });

export const symbolPut = <ThrowOnError extends boolean = false>(
  options: Options<SymbolPutData, ThrowOnError>
) =>
  (options.client ?? client).put<SymbolPutResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/symbols/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const symbolDefinitionsList = <ThrowOnError extends boolean = false>(
  options?: Options<SymbolDefinitionsListData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    SymbolDefinitionsListResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/symbols/definitions',
    ...options,
  });

export const getMigrationJob = <ThrowOnError extends boolean = false>(
  options: Options<GetMigrationJobData, ThrowOnError>
) =>
  (options.client ?? client).get<
    GetMigrationJobResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/taskmigration',
    ...options,
  });

export const startMigration = <ThrowOnError extends boolean = false>(
  options: Options<StartMigrationData, ThrowOnError>
) =>
  (options.client ?? client).post<
    StartMigrationResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/taskmigration',
    ...options,
  });

export const templateList = <ThrowOnError extends boolean = false>(
  options: Options<TemplateListData, ThrowOnError>
) =>
  (options.client ?? client).get<TemplateListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/templates',
    ...options,
  });

export const templatePost = <ThrowOnError extends boolean = false>(
  options: Options<TemplatePostData, ThrowOnError>
) =>
  (options.client ?? client).post<TemplatePostResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/projects/{projectId}/templates',
      ...options,
      headers: {
        'Content-Type': 'application/json-patch+json',
        ...options.headers,
      },
    }
  );

export const templateDelete = <ThrowOnError extends boolean = false>(
  options: Options<TemplateDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    TemplateDeleteResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/templates/{id}',
    ...options,
  });

export const templateGet = <ThrowOnError extends boolean = false>(
  options: Options<TemplateGetData, ThrowOnError>
) =>
  (options.client ?? client).get<TemplateGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/templates/{id}',
    ...options,
  });

export const templatePut = <ThrowOnError extends boolean = false>(
  options: Options<TemplatePutData, ThrowOnError>
) =>
  (options.client ?? client).put<TemplatePutResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/templates/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const templateGetLatestPublishedSeries = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TemplateGetLatestPublishedSeriesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TemplateGetLatestPublishedSeriesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/templates/series/latestpublishedtemplates',
    ...options,
  });

export const templateGetSeries = <ThrowOnError extends boolean = false>(
  options: Options<TemplateGetSeriesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TemplateGetSeriesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/templates/series/{seriesId}',
    ...options,
  });

export const templateGetLatestSeries = <ThrowOnError extends boolean = false>(
  options: Options<TemplateGetLatestSeriesData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TemplateGetLatestSeriesResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/templates/series/{seriesId}/latest',
    ...options,
  });

export const templateGetDeltas = <ThrowOnError extends boolean = false>(
  options: Options<TemplateGetDeltasData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TemplateGetDeltasResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/templates/deltas',
    ...options,
  });

export const templateGetLatestPublished = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TemplateGetLatestPublishedData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TemplateGetLatestPublishedResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/templates/latestpublishedtemplates',
    ...options,
  });

export const templateQuery = <ThrowOnError extends boolean = false>(
  options: Options<TemplateQueryData, ThrowOnError>
) =>
  (options.client ?? client).get<TemplateQueryResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/projects/{projectId}/templates/_query',
      ...options,
    }
  );

export const batchTemplateGetDeltas = <ThrowOnError extends boolean = false>(
  options: Options<BatchTemplateGetDeltasData, ThrowOnError>
) =>
  (options.client ?? client).post<
    BatchTemplateGetDeltasResponses,
    BatchTemplateGetDeltasErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/templates/deltas/_batch/_get',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

/**
 * @deprecated
 */
export const templateRelationshipsGet = <ThrowOnError extends boolean = false>(
  options: Options<TemplateRelationshipsGetData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TemplateRelationshipsGetResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/templates/relationships',
    ...options,
  });

/**
 * @deprecated
 */
export const templateRelationshipsCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<TemplateRelationshipsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TemplateRelationshipsCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/templates/relationships',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const templatePublicationPost = <ThrowOnError extends boolean = false>(
  options: Options<TemplatePublicationPostData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TemplatePublicationPostResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/templatepublications',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const templatePublicationQuery = <ThrowOnError extends boolean = false>(
  options: Options<TemplatePublicationQueryData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TemplatePublicationQueryResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/templatepublications/_query',
    ...options,
  });

/**
 * @deprecated
 */
export const trimbleDataGet = <ThrowOnError extends boolean = false>(
  options?: Options<TrimbleDataGetData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    TrimbleDataGetResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/trimbledata/services',
    ...options,
  });

export const trimbleDataGetGeocode = <ThrowOnError extends boolean = false>(
  options?: Options<TrimbleDataGetGeocodeData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    TrimbleDataGetGeocodeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/trimbledata/services/geocode',
    ...options,
  });

export const userSettingsGetByType = <ThrowOnError extends boolean = false>(
  options?: Options<UserSettingsGetByTypeData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    UserSettingsGetByTypeResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/settings',
    ...options,
  });

export const userSettingsPost = <ThrowOnError extends boolean = false>(
  options?: Options<UserSettingsPostData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    UserSettingsPostResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/settings',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options?.headers,
    },
  });

export const userSettingsDelete = <ThrowOnError extends boolean = false>(
  options: Options<UserSettingsDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    UserSettingsDeleteResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/settings/{id}',
    ...options,
  });

export const userSettingsGet = <ThrowOnError extends boolean = false>(
  options: Options<UserSettingsGetData, ThrowOnError>
) =>
  (options.client ?? client).get<
    UserSettingsGetResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/settings/{id}',
    ...options,
  });

export const userSettingsPut = <ThrowOnError extends boolean = false>(
  options: Options<UserSettingsPutData, ThrowOnError>
) =>
  (options.client ?? client).put<
    UserSettingsPutResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/settings/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const workspaceList = <ThrowOnError extends boolean = false>(
  options: Options<WorkspaceListData, ThrowOnError>
) =>
  (options.client ?? client).get<WorkspaceListResponses, unknown, ThrowOnError>(
    {
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/projects/{projectId}/spatialworkspaces',
      ...options,
    }
  );

export const workspacePost = <ThrowOnError extends boolean = false>(
  options: Options<WorkspacePostData, ThrowOnError>
) =>
  (options.client ?? client).post<
    WorkspacePostResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/spatialworkspaces',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const workspaceDelete = <ThrowOnError extends boolean = false>(
  options: Options<WorkspaceDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    WorkspaceDeleteResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/spatialworkspaces/{id}',
    ...options,
  });

export const workspaceGet = <ThrowOnError extends boolean = false>(
  options: Options<WorkspaceGetData, ThrowOnError>
) =>
  (options.client ?? client).get<WorkspaceGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/spatialworkspaces/{id}',
    ...options,
  });

export const workspacePatch = <ThrowOnError extends boolean = false>(
  options: Options<WorkspacePatchData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    WorkspacePatchResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/spatialworkspaces/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const workspacePut = <ThrowOnError extends boolean = false>(
  options: Options<WorkspacePutData, ThrowOnError>
) =>
  (options.client ?? client).put<WorkspacePutResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/spatialworkspaces/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const workspaceGetViewer = <ThrowOnError extends boolean = false>(
  options: Options<WorkspaceGetViewerData, ThrowOnError>
) =>
  (options.client ?? client).get<
    WorkspaceGetViewerResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/spatialworkspaces/viewer',
    ...options,
  });

export const workspaceGetSurvey = <ThrowOnError extends boolean = false>(
  options: Options<WorkspaceGetSurveyData, ThrowOnError>
) =>
  (options.client ?? client).get<
    WorkspaceGetSurveyResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/spatialworkspaces/survey',
    ...options,
  });

export const workspaceGetByFileId = <ThrowOnError extends boolean = false>(
  options: Options<WorkspaceGetByFileIdData, ThrowOnError>
) =>
  (options.client ?? client).get<
    WorkspaceGetByFileIdResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/spatialworkspaces/connectFileId/{fileId}',
    ...options,
  });

export const workspaceGetImage = <ThrowOnError extends boolean = false>(
  options: Options<WorkspaceGetImageData, ThrowOnError>
) =>
  (options.client ?? client).get<
    WorkspaceGetImageResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/spatialworkspaces/{id}/image',
    ...options,
  });

export const workspacePutImage = <ThrowOnError extends boolean = false>(
  options: Options<WorkspacePutImageData, ThrowOnError>
) =>
  (options.client ?? client).put<
    WorkspacePutImageResponses,
    unknown,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/spatialworkspaces/{id}/image',
    ...options,
    headers: {
      'Content-Type': null,
      ...options.headers,
    },
  });

export const workspaceRestore = <ThrowOnError extends boolean = false>(
  options: Options<WorkspaceRestoreData, ThrowOnError>
) =>
  (options.client ?? client).post<
    WorkspaceRestoreResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/spatialworkspaces/{id}/_restore',
    ...options,
  });

export const workspaceRelationshipsDelete = <
  ThrowOnError extends boolean = false,
>(
  options: Options<WorkspaceRelationshipsDeleteData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    WorkspaceRelationshipsDeleteResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/spatialworkspaces/{id}/relationships',
    ...options,
  });

export const workspaceRelationshipsPatch = <
  ThrowOnError extends boolean = false,
>(
  options: Options<WorkspaceRelationshipsPatchData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    WorkspaceRelationshipsPatchResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/spatialworkspaces/{id}/relationships',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const workspaceRelationshipsUpdate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<WorkspaceRelationshipsUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<
    WorkspaceRelationshipsUpdateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/spatialworkspaces/{id}/relationships',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const workspaceListOrphan = <ThrowOnError extends boolean = false>(
  options: Options<WorkspaceListOrphanData, ThrowOnError>
) =>
  (options.client ?? client).get<
    WorkspaceListOrphanResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/spatialworkspaces/orphans',
    ...options,
  });

export const workspaceQuery = <ThrowOnError extends boolean = false>(
  options: Options<WorkspaceQueryData, ThrowOnError>
) =>
  (options.client ?? client).get<
    WorkspaceQueryResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/spatialworkspaces/_query',
    ...options,
  });

export const workspaceDuplicatePost = <ThrowOnError extends boolean = false>(
  options: Options<WorkspaceDuplicatePostData, ThrowOnError>
) =>
  (options.client ?? client).post<
    WorkspaceDuplicatePostResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/spatialworkspaces/DuplicateAsync',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });

export const workspaceImportPost = <ThrowOnError extends boolean = false>(
  options: Options<WorkspaceImportPostData, ThrowOnError>
) =>
  (options.client ?? client).post<
    WorkspaceImportPostResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/projects/{projectId}/spatialworkspaces/ImportAsync',
    ...options,
    headers: {
      'Content-Type': 'application/json-patch+json',
      ...options.headers,
    },
  });
